export default __webpack_public_path__ + "static/media/otter_square.8fde15c0.svg";